export default __webpack_public_path__ + "static/media/sweetSvg.2acf30a7.svg";